import { Button } from "@fluentui/react-components";
import styled from "styled-components";

export const AttachFilePopoverWrapper = styled.div``;

export const StyledButton = styled(Button)`
  color: ${(props) => props.theme.selectedDateBackground};
  background-color: transparent;
  border: none;
`;